import React from 'react';
import { motion } from 'framer-motion';

const PrivacyPolicy = () => {
  return (
    <div className="bg-white py-20">
      <div className="container mx-auto px-4 md:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="text-3xl md:text-4xl font-medium mb-8 text-gray-900">Politique de confidentialité</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700">
            <p className="mb-6">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">1. Introduction</h2>
            <p>
              Chez Aiko, nous accordons une grande importance à la protection de vos données personnelles. 
              Cette politique de confidentialité vous explique comment nous collectons, utilisons, partageons 
              et protégeons vos informations lorsque vous visitez notre site web ou utilisez nos services.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">2. Informations que nous collectons</h2>
            <p>
              Nous pouvons collecter les types d'informations suivants :
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li><strong>Informations personnelles</strong> : nom, adresse e-mail, numéro de téléphone, lorsque vous nous contactez ou utilisez notre formulaire de contact.</li>
              <li><strong>Informations de navigation</strong> : adresse IP, type de navigateur, pages visitées, temps passé sur le site, via des cookies et technologies similaires.</li>
              <li><strong>Informations sur l'appareil</strong> : type d'appareil, système d'exploitation, identifiants uniques.</li>
            </ul>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">3. Utilisation de vos informations</h2>
            <p>
              Nous utilisons vos informations pour :
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Fournir, maintenir et améliorer nos services</li>
              <li>Communiquer avec vous concernant nos services</li>
              <li>Personnaliser votre expérience sur notre site</li>
              <li>Analyser l'utilisation de notre site web</li>
              <li>Protéger notre site et nos utilisateurs</li>
            </ul>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">4. Partage de vos informations</h2>
            <p>
              Nous ne vendons pas vos informations personnelles. Nous pouvons partager vos informations dans les cas suivants :
            </p>
            <ul className="list-disc pl-6 mb-6">
              <li>Avec des prestataires de services qui nous aident à gérer notre site et nos services</li>
              <li>Pour se conformer à la loi ou à une procédure judiciaire</li>
              <li>Pour protéger nos droits, notre propriété ou notre sécurité</li>
              <li>Dans le cadre d'une fusion, acquisition ou vente d'actifs</li>
            </ul>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">5. Cookies et technologies similaires</h2>
            <p>
              Nous utilisons des cookies et technologies similaires pour collecter des informations sur votre navigation, 
              personnaliser votre expérience et analyser l'utilisation de notre site. Vous pouvez configurer votre navigateur 
              pour refuser les cookies, mais cela pourrait affecter certaines fonctionnalités de notre site.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">6. Sécurité des données</h2>
            <p>
              Nous prenons des mesures raisonnables pour protéger vos informations contre la perte, le vol, l'utilisation 
              abusive et l'accès non autorisé. Cependant, aucune méthode de transmission sur Internet ou de stockage 
              électronique n'est totalement sécurisée.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">7. Vos droits</h2>
            <p>
              Selon les lois applicables, vous pouvez avoir le droit d'accéder, de corriger, de supprimer ou de limiter 
              l'utilisation de vos informations personnelles. Pour exercer ces droits, veuillez nous contacter à l'adresse 
              indiquée ci-dessous.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">8. Modifications de cette politique</h2>
            <p>
              Nous pouvons mettre à jour cette politique de confidentialité de temps à autre. La date de la dernière mise 
              à jour sera indiquée en haut de cette page. Nous vous encourageons à consulter régulièrement cette politique.
            </p>
            
            <h2 className="text-2xl font-medium mt-8 mb-4 text-gray-800">9. Nous contacter</h2>
            <p>
              Si vous avez des questions concernant cette politique de confidentialité, veuillez nous contacter à :
              <br />
              <a href="mailto:contact@aiko.fr" className="text-indigo-600 hover:text-indigo-800">contact@aiko.fr</a>
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
